
import axios from "axios";

const saveUserInfo = (user_data, successHook, failHook) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        try{
            axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/api/update-user-info/`, {
                user_data
            },{
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then((response)=>{
                if (response.status === 200) {
                    successHook('Successfully updated user info.');
                } else {
                    failHook("Unable to save user data.");
                }
            })
            .catch((error)=>{
                failHook("Unable to save user data");
            })
        } catch (err) {
            failHook("Unable to save user data");
        }
    } else {
        failHook("Your session is not authenticated, please log out and sign in again.");
    }
};

export default saveUserInfo;